module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon_section_new.d091c.png";